<script setup lang="ts">
import {SimpleValueWidget} from "@/laboratory/components/dashboard/dashboard";
import {Widget} from "@/laboratory/components/dashboard/components/widget";

defineProps<{
    widget: SimpleValueWidget;
}>();
</script>

<template>
  <Widget :widget="widget">
    <div>
      <label class="text-lg font-bold">{{ widget.data.value }}</label>
    </div>
  </Widget>
</template>

<style scoped>

</style>
